
const wstQueryMainRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `query/wst/index${i + 1}`,
  name: `queryWstIndex${i + 1}`,
  component: () => import(`@/views/health/query/wst/index${i + 1}.vue`),
}));


export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [
    // 预约挂号——皖事通，主流程
    ...wstQueryMainRoutes,
  ],
};
